import React, { useState, useEffect, useRef } from "react";

import { HiMenu } from "react-icons/hi";
import { AiFillCloseCircle } from "react-icons/ai";

import { Route, Routes, Link } from "react-router-dom";
import { Sidebar, UserProfile } from "../components";
import { client } from "../client";
import { userQuery } from "../utils/data";

import Pins from "./Pins";
export const Home = () => {
  const [user, setUser] = useState();

  const [toggleSideBar, setToggleSidebar] = useState(false);
  const scrollRef = useRef(null);

  const userInfo =
    localStorage.getItem("user") !== "undefined"
      ? JSON.parse(localStorage.getItem("user"))
      : null;

  useEffect(() => {
    const query = userQuery(userInfo?.jti);
    client
      .fetch(query)
      .then((data) => {
       
        setUser(data[0]); // Assuming you want to set the first result to the user state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    scrollRef.current.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="flex flex-col h-screen md:flex-row transition-height duration-75 ease-out">
        <div className="hidden md:flex h-screen flex-initial">
          <Sidebar user={user && user} />
        </div>
        <div className="flex md:hidden flex-row">
          <div className="p-2 w-full flex flex-row justify-between shadow-md">
            <HiMenu
              fontSize={20}
              className="cursor-point"
              onClick={() => setToggleSidebar(true)}
            />
            <Link to={`user-profile/${user?._id}`}>
              <img src={user?.image} alt="logoss" className="w-28" />
            </Link>
          </div>
          {toggleSideBar && (
            <div className="fixed w-4/5 bg-white h-screen overflow-y-auto shadow-md z-10 animate-slide-in">
              <div className="absolute w=full flex justify-end items-center py-2 right-0">
                <AiFillCloseCircle
                  fontSize={36}
                  className="text-gray-900 cursor-pointer "
                  onClick={() => setToggleSidebar(false)}
                />
              </div>
              <Sidebar user={user && user} closeToggle={setToggleSidebar} />
            </div>
          )}

          {/* Desktop */}
        </div>
        <div
          className="pb-2 flex-1 h-screen overflow-y-scroll "
          ref={scrollRef}
        >
          <Routes>
            <Route path="/user-profile/:userId" element={<UserProfile />} />
            <Route path="/*" element={<Pins user={user && user} />} />
          </Routes>
        </div>
      </div>
    </>
  );
};
